export interface UpdateModalSection {
  title: string;
  content: string;
}

export const ANDREA_UPDATE_MODAL = {
  headerTitle: 'Version 3.2.0 — Mock Interview Updates',
  footerLinkLabel: 'Update settings',
  image: {
    src: '/assets/Update_3.2.0.png',
    alt: 'LUCI version 3.2.0 — New Update',
  },
  sections: [
    {
      title: 'See what just arrived',
      content:
        'We have just rolled out key enhancements to our Mock Interview platform to make candidate practice sessions faster, smoother, and more realistic:\n\n- **Faster AI Thinking** — Significantly reduced latency for quicker, more natural response times.\n- **Upgraded Audio & Transcription** — Enhanced speech-to-text accuracy and brand-new, realistic interviewer voices.\n- **Better Interview Models** — Sharper evaluation capabilities tailored to interview prep.',
    },
    {
      title: 'How to apply these updates to your account',
      content:
        'To start using the new features right away, please update your configuration by following these steps:\n\n- Log in to your platform dashboard.\n- Navigate to the **Settings** page from the sidebar.\n- Under **Interviewer Model**, select **LUCI (thinking)** as Interview Model and then select\n  - Interviewer Persona\n  - Interviewer Voice\n- Click **Save Changes**.\n\nOnce updated, all upcoming mock interview sessions will automatically run on the upgraded setup.',
    },
  ] satisfies UpdateModalSection[],
};
